import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

// FIXED: Now accepts companyId and appends it to the URL
export const fetchDepartments = createAsyncThunk(
  "department/fetchDepartments",
  async (companyId, { rejectWithValue }) => { 
    try {
      // If companyId is provided, append it as a query parameter
      const url = companyId 
        ? `${API_URL}/companies/department?companyId=${companyId}` 
        : `${API_URL}/companies/department`;
        
      const response = await axios.get(url);
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to fetch departments";
      return rejectWithValue(Array.isArray(msg) ? msg.join(", ") : msg);
    }
  }
);

export const createDepartment = createAsyncThunk(
  "department/createDepartment",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/companies/department`, {
        departmentName: data.departmentName,
        description: data.description,
        isActive: data.isActive,
      });
      dispatch(fetchDepartments(data.companyId)); // Refresh for specific company
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to create department";
      return rejectWithValue(Array.isArray(msg) ? msg.join(", ") : msg);
    }
  }
);

export const updateDepartment = createAsyncThunk(
  "department/updateDepartment",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${API_URL}/companies/department/${id}`, {
        departmentName: data.departmentName,
        description: data.description,
        isActive: data.isActive,
      });
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to update department";
      return rejectWithValue(Array.isArray(msg) ? msg.join(", ") : msg);
    }
  }
);

export const toggleDepartmentStatus = createAsyncThunk(
  "department/toggleStatus",
  async ({ id, currentStatus }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${API_URL}/companies/department/${id}`, {
        isActive: !currentStatus,
      });
      return response.data;
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to toggle status";
      return rejectWithValue(Array.isArray(msg) ? msg.join(", ") : msg);
    }
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    list: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearDepartmentError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDepartments.pending, (state) => { state.status = "loading"; })
      .addCase(fetchDepartments.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchDepartments.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(createDepartment.fulfilled, (state) => { state.status = "succeeded"; })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.list = state.list.map((dept) => dept.id === action.payload.id ? action.payload : dept);
      })
      .addCase(toggleDepartmentStatus.fulfilled, (state, action) => {
        state.list = state.list.map((dept) => dept.id === action.payload.id ? action.payload : dept);
      });
  },
});

export const { clearDepartmentError } = departmentSlice.actions;
export default departmentSlice.reducer;